import { toFormElementFromParameter } from "../../../../global/functions/mappingForParameterToFormElement";

export default {
  data() {
    return {
      jsonParam: {
        bez: "_LBL_KOBJEKTICON_ICON_",
        default: null,
        help_text: "_TXT_KOBJEKTICON_ICON_HELP_TEXT_",
        readonly: false,
        options: {
          allow_null: false,
          required: true
        },
        typ: "validated_json",
        many: false,
        as_json: true,
        unique_fields: [],
        key_field: null,
        pos_field: null,
        min_length: null,
        max_length: null,
        element_label: "Element",
        element_template: "{{element_label}}",
        element_errors: false,
        deactivate_ordering: false,
        deactivate_preview: false,
        hide_pos: false,
        optional_single_label: "_LBL_ICON_CONFIG_OPTIONAL_SINGLE_LABEL_",
        optional_single_default: false,
        fields: {
          icon: {
            prio: 0,
            bez: "_LBL_ICON_CONFIG_ICON_",
            default: null,
            help_text: "_TXT_ICON_CONFIG_ICON_HELP_",
            readonly: false,
            options: {
              allow_null: false,
              required: true,
            },
            hideLabel: true,
            typ: "select_icons",
            statusHideErrorsBottom: true
          },
          style: {
            prio: 1,
            bez: "_LBL_ICON_CONFIG_STYLE_",
            default: null,
            help_text: "_TXT_ICON_CONFIG_STYLE_HELP_",
            readonly: false,
            options: {
              allow_null: true,
              required: false
            },
            typ: "single_choice",
            choices: [
              [
                "a_color_primary",
                "Primary"
              ],
              [
                "a_color_secondary",
                "Secondary"
              ],
              [
                "a_color_tertiary",
                "Tertiary"
              ],
              [
                "a_color_text",
                "Text"
              ],
              [
                "a_color_info",
                "Info"
              ],
              [
                "a_color_success",
                "Success"
              ],
              [
                "a_color_warning",
                "Warning"
              ],
              [
                "a_color_danger",
                "Danger"
              ],
              [
                "a_color_link",
                "Link"
              ],
              [
                "a_color_white",
                "White"
              ],
              [
                "a_color_black",
                "Black"
              ],
              [
                "a_color_gray_100",
                "Gray (100)"
              ],
              [
                "a_color_gray_200",
                "Gray (200)"
              ],
              [
                "a_color_gray_300",
                "Gray (300)"
              ],
              [
                "a_color_gray_400",
                "Gray (400)"
              ],
              [
                "a_color_gray_500",
                "Gray (500)"
              ],
              [
                "a_color_gray_600",
                "Gray (600)"
              ],
              [
                "a_color_gray_700",
                "Gray (700)"
              ],
              [
                "a_color_gray_800",
                "Gray (800)"
              ],
              [
                "a_color_gray_900",
                "Gray (900)"
              ],
              [
                "a_color_transparent",
                "Transparent"
              ]
            ]
          },
          title: {
            prio: 2,
            bez: "_LBL_ICON_CONFIG_TITLE_",
            default: null,
            help_text: "_TXT_ICON_CONFIG_TITLE_HELP_",
            readonly: false,
            options: {
              allow_null: false,
              required: true,
              max_length: null,
              min_length: null
            },
            typ: "string"
          },
          preview: {
            prio: 3,
            bez: "_LBL_ICON_CONFIG_PREVIEW_",
            default: null,
            help_text: "_TXT_ICON_CONFIG_PREVIEW_HELP_",
            readonly: true,
            options: {
              allow_null: false,
              required: true,
              max_length: null,
              min_length: null
            },
            typ: "icon_config"
          }
        },
      }
    };
  },
  computed: {
    jsonOptions() {
      return toFormElementFromParameter({
        obj: { dimensionen: this.jsonParam },
        showLabel: true,
        staticOptions: {
          required: this.options.required,
          options: this.options.options,
          showReadonly: true,
        },
      }).list[0];
    },
  },
};
